"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendFormExpirationOptions = void 0;
exports.SendFormExpirationOptions = [
    { value: '1d', label: 'One (1) Day', description: 'one day' },
    { value: '3d', label: 'Three (3) Days', description: 'three days' },
    { value: '1w', label: 'One (1) Week', description: 'one week' },
    { value: '2w', label: 'Two (2) Weeks', description: 'two weeks' },
    { value: '30d', label: 'One (1) Month', description: 'one month' }
];
//# sourceMappingURL=SendFormPlugin.js.map